<!--HeaderNavgation:官网导航 2021/02/25 14:43:17 YuAng-->
<template>
  <div class="its-navigation" :class="type">
    <div class="its-navigation-aside left">
      <a href="/official/" class="its-navigation-logo">
        <img alt="学科网e课堂-智慧教学" :src="getSrc(type)">
      </a>
    </div>
    <div class="its-navigation-mid" :class="[classTag]">
      <div class="its-navigation-list">
        <template v-for="navigator in navigators">
          <div v-if="!navigator.children || navigator.children.length === 0" :key="navigator.path" class="el-dropdown" @click="handleCommand(navigator.id)">
            <span :id="'nav-' + type + navigator.id" class="el-dropdown-link" :class="navigator.active ? 'active': ''">
              {{navigator.title}}
            </span>
          </div>
          <el-dropdown v-else :key="'navigator' + navigator.id" placement="bottom" @command="handleCommand">
            <span :id="'nav-' + type + navigator.id" class="el-dropdown-link" :class="navigator.active ? 'active': ''">
              {{navigator.active ? navigator.title : navigator.defaultTitle}}
              <i class="el-icon--right" :class="navigator.show ? 'el-icon-arrow-up': 'el-icon-arrow-down'"></i>
            </span>
            <el-dropdown-menu v-show="navigator.children.length > 0" slot="dropdown">
              <el-dropdown-item v-for="child in navigator.children" :key="child.id" :command="child.id" :class="child.active ? 'active': ''">
                <span v-if="child.tip" :title="child.tip">{{child.title}}</span>
                <span v-else>{{child.title}}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </div>
    </div>
    <div class="its-navigation-aside right" :style="{width: aside + 'px'}">
      <div class="its-navigation-user">
        <button class="its-base-btn its-primary-btn its-download its-apply" :class="[$route.name ==='Apply' ? 'active': '']" @click="jump2Apply()">试用申请</button>
        <button class="its-base-btn its-primary-btn its-download" :class="{'active' : $route.name ==='Download'}" @click="jump2Download()">下载中心</button>
        <button class="its-base-btn its-login" @click="jump2Login()">{{loginName}}</button>
      </div>
    </div>
    <span v-show="showUnderline" class="navigation-active-line" :style="underlineStyle"></span>
    <p style="clear: both"></p>
  </div>
</template>
<script>
import { userApi } from '../../../../utils/api'
export default {
  name: 'HeaderNavgation',
  data() {
    return {
      type: 'transparent',
      aside: 360,
      showUnderline: true,
      underlineStyle: '',
      navigators: [
        { id: '1', title: '首页', url: '/', mobileUrl: '/eclass/mobile/home', active: false },
        {
          id: '2',
          title: '产品介绍',
          defaultTitle: '产品介绍',
          active: false,
          children: [
            { id: '2-1', title: '学校智慧教学解决方案', url: '/eclass/school', mobileUrl: '/eclass/mobile/school', active: false },
            { id: '2-2', title: '区域智慧教育解决方案', url: '/eclass/area', mobileUrl: '/eclass/mobile/area', active: false }
          ]
        },
        { id: '3', title: '培训专区', url: 'http://go.plvideo.cn/album/index.html?albumId=0cbdd75d', active: false },
        { id: '4', title: '示范案例', url: '/eclass/cases', active: false },
        { id: '6', title: '关于我们', url: '/eclass/about', active: false }
      ],
      current: { active: false, id: '1' },
      loginName: '登录'
    }
  },
  computed: {
    classTag: function () {
      return this.navigators.length > 8 ? 'count9' : ''
    }
  },
  created() {
    this.type = this.$route.meta.header
    userApi.login().then((resp) => {
      if (resp.body) {
        this.loginName = '进入平台'
      }
    })
    const base = '/official'
    let target = location.pathname === base + '/' ? this.navigators[0] :  null
    for (let index = 1; index < this.navigators.length; index++) {
      const item = this.navigators[index];
      if (item.children) {
        const child = item.children.find(item => location.pathname.indexOf(item.url) >= 0)
        if (child) {
          target = child
          break
        }
      } else if (location.pathname.indexOf(item.url) >= 0) {
        target = item
        break
      }
    }
    if (target) {
      if (window.screen.width > 1000) {
        this.current = target
      } else if (location.href.indexOf('localhost') === -1) {
        const url = base + target.mobileUrl
        window.open(url, '_self')
        setTimeout(() => {
          location.reload()
        }, 1);
      }
    }
  },
  mounted() {
    if (this.current && this.current.url) {
      this.handleCommand(this.current.id)
    } else {
      this.cancelActive()
    }
  },
  methods: {
    handleCommand: function (command) {
      const navigatorId = this.current.id // 记录上次的导航id
      this.setActive(command)
      if (this.current.url.indexOf('http') === -1) {
        this.$router.push(this.current.url)
      } else {
        // 如果是绝对地址，那么单独打开一个标签页
        const url = this.current.url // 记录当前url
        this.setActive(navigatorId) // 恢复上个导航的选中效果
        window.open(url, '_blank')
      }
    },
    jump2Login: function () {
      const service = location.origin + '/ibook/shiro-cas?client_name=CasClient'
      // ?dialogTheme=true&withBg=true
      const url = process.env.VUE_APP_URL_LOGIN + "/login?service=" + encodeURIComponent(service)
      window.open(url, '_self')
    },
    jump2Download: function () {
      this.cancelActive()
      this.$router.push('/eclass/download')
    },
    jump2Apply: function () {
      this.cancelActive()
      this.$router.push('/apply/submit')
    },
    setActive: function (command) {
      console.log(command)
      this.cancelActive()
      if (command.includes('-')) {
        const parent = this.navigators.find(item => item.id === command.split('-')[0])
        const child = parent.children.find(item => item.id === command)
        parent.title = child.title
        parent.active = true
        this.current = child
      } else {
        this.current = this.navigators.find(item => item.id === command)
      }
      this.current.active = true
      this.$nextTick(function () {
        this.setUnderline()
      })
    },
    cancelActive: function () {
      this.current.active = false
      if (this.current.id.includes('-')) {
        this.navigators.find(item => item.id === this.current.id.split('-')[0]).active = false
      }
      this.showUnderline = false
    },
    setUnderline: function () {
      this.showUnderline = true
      let navId = this.current.id
      if (navId.includes('-')) {
        navId = navId.split('-')[0]
      }
      let id = 'nav-' + this.type + navId
      let target = document.getElementById(id)
      if (target) {
        let position = target.getBoundingClientRect()
        let style = {
          left: position.left + 'px',
          width: position.width + 'px',
          background: 'white'
        }
        this.underlineStyle = style
      }
    },
    getSrc: function (type) {
      if (type === 'primary') {
        return require('@/assets/images/logo_color.png')
      } else {
        return require('@/assets/images/logo_white.png')
      }
    }
  },
  watch: {
    $route: {
      handler: function (to) {
        // 当是以下页面的时候取消中间导航项目的选中
        if (['Download', 'Apply'].indexOf(to.name) !== -1) {
          this.cancelActive()
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.its-navigation {
  color: blue;
  height: 80px;
  background: transparent;
  width: 100%;
  position: fixed;
  z-index: 2000;
}

.its-navigation > div {
  float: left;
  height: 100%;
}

.its-navigation-mid {
  width: calc(100% - 360px * 2);
  text-align: center;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
}

.its-navigation-aside {
  width: 360px;
}

.navigation-active-line {
  width: 50px;
  height: 3px;
  background: white;
  position: absolute;
  bottom: 0;
  left: 0;
}

.its-navigation-mid >>> .el-dropdown {
  margin-right: 38px;
  margin-top: 30px;
  cursor: pointer;
  outline: 0;
  font-size: 16px;
  color: #333333;
  font-weight: 400;
}

.its-navigation-mid.count9 >>> .el-dropdown {
  margin-right: 30px;
}

.el-dropdown-menu__item.active {
  background-color: #ecf5ff;
  color: #66b1ff !important;
}

.el-dropdown-link:hover,
.el-dropdown-link.active {
  color: #5591fe;
}

.its-navigation.primary {
  background-color: white;
  border-bottom: 1px solid #f1f1f1;
  box-shadow: 0 5px 10px -5px rgba(134, 134, 134, 0.3);
}

.its-navigation-logo {
  /* height: 40px; */
  max-width: 250px;
  float: left;
  margin-left: 50px;
  margin-top: 12px;
}

.its-navigation-logo img {
  height: 100%;
}

.its-navigation-user {
  margin-top: 20px;
  float: right;
  margin-right: 50px;
}

.its-navigation-user .its-base-btn {
  float: left;
  border-radius: 16px;
  border: none;
  font-size: 16px;
  color: #000000;
  border-radius: 0;
  padding: 0;
  height: 40px;
  line-height: 40px;
}

.its-navigation-user .its-download:hover {
  background-color: transparent !important;
  color: #4390ff;
}

.its-navigation-user .its-base-btn.active {
  border-bottom: 1px solid #4390ff;
  color: #4390ff;
}

.its-navigation-user .its-login {
  color: white;
  background: #4390ff;
  margin-left: 32px;
  width: 100px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
}

.its-navigation.primary .its-login:hover {
  opacity: 0.8;
  color: white !important;
}

/* 透明的导航栏 */

.its-navigation.transparent {
  background-color: transparent;
}

.its-navigation.transparent >>> .el-dropdown {
  color: white;
}

.its-navigation.transparent >>> .el-dropdown-link:hover,
.its-navigation.transparent >>> .el-dropdown-link.active {
  color: white;
}

.its-navigation.transparent .its-download {
  background: transparent;
  color: white;
  border-color: white;
}

.its-navigation.transparent .its-download:hover {
  opacity: 0.8;
}

.its-apply {
  margin-right: 40px;
}

.its-navigation.transparent .its-login {
  background: rgba(255, 255, 255, 0.4);
}
</style>

